import { create } from 'zustand';
import { BookingListSummaryDto } from 'Util/_HumanWritten/Bookings/FetchBookingsWithFilters';

interface BookingListStore {
	totalCountOfUpcomingBookings: number;
	totalCountOfPastBookings: number;
	upcomingBookings: BookingListSummaryDto[] | null;
	pastBookings: BookingListSummaryDto[] | null;
	setTotalCountOfUpcomingBookings: (newCount: number) => void;
	setTotalCountOfPastBookings: (newCount: number) => void;
	setUpcomingBookings: (newBookings: BookingListSummaryDto[] | null) => void;
	setPastBookings: (newBookings: BookingListSummaryDto[] | null) => void;
	addToUpcomingBookings: (newBookings: BookingListSummaryDto[]) => void;
	addToPastBookings: (newBookings: BookingListSummaryDto[]) => void;
}

export const bookingListStore = create<BookingListStore>(set => ({
	totalCountOfUpcomingBookings: 0,
	totalCountOfPastBookings: 0,
	upcomingBookings: null,
	pastBookings: null,
	setTotalCountOfUpcomingBookings: (newCount: number) => set({ totalCountOfUpcomingBookings: newCount }),
	setTotalCountOfPastBookings: (newCount: number) => set({ totalCountOfPastBookings: newCount }),
	setUpcomingBookings: (newBookings: BookingListSummaryDto[] | null) => set({ upcomingBookings: newBookings }),
	setPastBookings: (newBookings: BookingListSummaryDto[] | null) => set({ pastBookings: newBookings }),
	addToUpcomingBookings: (newBookings: BookingListSummaryDto[]) =>
		set(state => ({ upcomingBookings: [...(state.upcomingBookings || []), ...newBookings] })),
	addToPastBookings: (newBookings: BookingListSummaryDto[]) =>
		set(state => ({ pastBookings: [...(state.pastBookings || []), ...newBookings] })),
}));
